'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _reduxForm = require('redux-form');

var _components = require('components');

var _applicationForm = require('redux/modules/applicationForm');

var applicationFormActions = _interopRequireWildcard(_applicationForm);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactLazyLoad = require('react-lazy-load');

var _reactLazyLoad2 = _interopRequireDefault(_reactLazyLoad);

var _reactRouter = require('react-router');

var _Content = require('./../../helpers/Content');

var _Content2 = _interopRequireDefault(_Content);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SuburbanCamp = (_dec = (0, _reactRedux.connect)(function () {
  return {};
}, { initialize: _reduxForm.initialize }), _dec2 = (0, _reactRedux.connect)(function () {
  return {};
}, function (dispatch, ownProps) {
  var mappedProps = (0, _redux.bindActionCreators)(applicationFormActions, dispatch);
  mappedProps.params = ownProps.params;
  return mappedProps;
}), _dec(_class = _dec2(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(SuburbanCamp, _Component);

  function SuburbanCamp() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SuburbanCamp);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SuburbanCamp.__proto__ || (0, _getPrototypeOf2.default)(SuburbanCamp)).call.apply(_ref, [this].concat(args))), _this), _this.handleSubmit = function (data) {
      _this.props.saveApplicationForm(data).then(function () {
        _this.props.hideForm();
      }).catch(function (err) {
        window.alert('Je nám líto, ale někde se stala chyba :( Zkuste to prosím ještě jednou nebo napište na info@nenudimse.cz. ' + (0, _stringify2.default)(err));
      });
    }, _this.handleRepeat = function () {
      _this.props.showForm();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SuburbanCamp, [{
    key: 'render',
    value: function render() {
      var styles = require('./SuburbanCamp.scss');
      var styles2 = require('./../SuburbanCamps/SuburbanCamps.scss');
      var photoIntro = require('./../SuburbanCamps/suburban-camps-intro.jpg');
      var photos = {
        photo1: require('./../SuburbanCamps/suburban-camps1.jpg'),
        photo2: require('./../SuburbanCamps/suburban-camps2.jpg'),
        photo3: require('./../SuburbanCamps/suburban-camps3.jpg'),
        photo4: require('./../SuburbanCamps/suburban-camps4.jpg'),
        photo5: require('./../SuburbanCamps/suburban-camps5.jpg'),
        photo6: require('./../SuburbanCamps/suburban-camps6.jpg')
      };
      var preFilled = {
        type: 'suburban-camp'
      };
      var lazyLoadOffset = 200;
      var dateParam = this.props.params.date;
      var pageParams = {
        heading: 'Příměstský tábor'
      };

      if (typeof dateParam !== 'undefined') {
        switch (dateParam) {
          case '13.-17.8.2018':
            preFilled.variant = preFilled.type + '-2018-08-13-17';
            pageParams.date = '13.-17.8.2018';
            pageParams.content = 'Příměstský tábor v Třebotově a Radotíně - kousek za Prahou. Každé ráno se sejdeme na nádraží v Praze a dojedeme do Třebotova nebo Radotína, kde bude probíhat celodenní sportovní a výtvarný program. V pozdních odpolední hodinách se vrátíme opět na nádraží v Praze.';
            break;

          case '20.-24.8.2018':
            preFilled.variant = preFilled.type + '-2018-08-20-24';
            pageParams.date = '20.-24.8.2018';
            pageParams.content = 'Příměstský tábor v Třebotově a Radotíně - kousek za Prahou. Každé ráno se sejdeme na nádraží v Praze a dojedeme do Třebotova nebo Radotína, kde bude probíhat celodenní sportovní a výtvarný program. V pozdních odpolední hodinách se vrátíme opět na nádraží v Praze.';
            break;

          case '19.-23.8.2019':
            preFilled.variant = preFilled.type + '-2019-08-19-23';
            pageParams.date = '19.-23.8.2019';
            pageParams.content = 'Příměstský tábor se koná nedaleko Prahy v Radotíně a Třebotově a je určen pro děti od 5 do 13 let. Každý den v ranních hodinách se sejdeme na Smíchovském nádraží v Praze (po domluvě je možný sraz také na nádraží Vršovice), odkud vyjedeme směr Radotín, kde začne sportovní program. Během dopoledního programu budeme jezdit na in-line bruslích nebo sportovat na fotbalovém hřišti v Třebotově. Oběd je zajištěný v místní restauraci. Po obědě nás čeká polední klid, během kterého se děti věnují společenským hrám, umělecké činnosti, nebo lukostřelbě. Odpoledne nás čekají tematické hry ve skupinách, které nás budou provázet celým táborem a vedou děti ke spolupráci ve skupině. Podle počasí budeme s dětmi chodit plavat do Biotopu Radotín, který nabízí přírodně čištěný bazén bez chlóru. Po skončení programu je zajištěna doprava zpět na Smíchovské nádraží nebo, po individuální domluvě, na nádraží Vršovice.';
            break;

          case '26.-30.8.2019':
            preFilled.variant = preFilled.type + '-2019-08-26-30';
            pageParams.date = '26.-30.8.2019';
            pageParams.content = 'Příměstský tábor se koná nedaleko Prahy v Radotíně a Třebotově a je určen pro děti od 5 do 13 let. Každý den v ranních hodinách se sejdeme na Smíchovském nádraží v Praze (po domluvě je možný sraz také na nádraží Vršovice), odkud vyjedeme směr Radotín, kde začne sportovní program. Během dopoledního programu budeme jezdit na in-line bruslích nebo sportovat na fotbalovém hřišti v Třebotově. Oběd je zajištěný v místní restauraci. Po obědě nás čeká polední klid, během kterého se děti věnují společenským hrám, umělecké činnosti, nebo lukostřelbě. Odpoledne nás čekají tematické hry ve skupinách, které nás budou provázet celým táborem a vedou děti ke spolupráci ve skupině. Podle počasí budeme s dětmi chodit plavat do Biotopu Radotín, který nabízí přírodně čištěný bazén bez chlóru. Po skončení programu je zajištěna doprava zpět na Smíchovské nádraží nebo, po individuální domluvě, na nádraží Vršovice.';
            break;

          default:
            break;
        }
      }

      var data = {
        intro: {
          text: pageParams.content,
          image: {
            src: photoIntro,
            alt: 'Dětské tábory pro všechny'
          }
        }
      };

      this.props.initialize('application-form', preFilled);

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_reactHelmet2.default, {
          title: pageParams.heading + ' ' + pageParams.date,
          meta: [{
            name: 'description',
            content: pageParams.heading + ' ' + pageParams.date
          }, {
            property: 'og:description',
            content: pageParams.heading + ' ' + pageParams.date
          }, {
            property: 'og:title',
            content: pageParams.heading + ' ' + pageParams.date
          }, {
            name: 'keywords',
            content: 'příměstský tábor, příměstské tábory, Praha, dětský tábor, dětský sportovní tábor, dětské sportovní tábory, letní tábor, letní tábory, letní tábory pro děti'
          }],
          link: [{ rel: 'canonical', href: 'https://www.nenudimse.cz/primestske-tabory/' + pageParams.date }] }),
        _react2.default.createElement(
          'header',
          null,
          _react2.default.createElement(
            'h1',
            null,
            pageParams.heading,
            ' ',
            _react2.default.createElement(
              'small',
              null,
              pageParams.date
            )
          )
        ),
        _Content2.default.renderIntro(styles2, data.intro),
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)('container-fluid', styles.photos) },
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col-xs-6' },
              _react2.default.createElement(
                _reactLazyLoad2.default,
                { offsetBottom: lazyLoadOffset, offsetTop: lazyLoadOffset },
                _react2.default.createElement('img', { src: photos.photo1, alt: 'D\u011Btsk\xFD t\xE1bor Nenud\xEDm se' })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-xs-6' },
              _react2.default.createElement(
                _reactLazyLoad2.default,
                { offsetBottom: lazyLoadOffset, offsetTop: lazyLoadOffset },
                _react2.default.createElement('img', { src: photos.photo2, alt: 'D\u011Btsk\xFD t\xE1bor Nenud\xEDm se' })
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: (0, _classnames2.default)('col-xs-12') },
              _react2.default.createElement(
                'h2',
                null,
                'Stravov\xE1n\xED'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Ob\u011Bd je zaji\u0161t\u011Bn v\xA0t\u0159ebotovsk\xE9 restauraci U Kr\xE1l\u016F. J\xEDme zde ji\u017E t\u0159et\xEDm rokem a v\u017Edy si s\xA0d\u011Btmi na j\xEDdle pochutn\xE1me. Dopoledne a odpoledne budou pro d\u011Bti zaji\u0161t\u011Bny sva\u010Dinky. Pitn\xFD re\u017Eim je zaji\u0161t\u011Bn\xFD po cel\xFD den.'
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: (0, _classnames2.default)('col-xs-12') },
              _react2.default.createElement(
                'h2',
                null,
                'N\xE1pl\u0148 t\xE1bora'
              ),
              _react2.default.createElement(
                'div',
                { className: 'row' },
                _react2.default.createElement(
                  'div',
                  { className: (0, _classnames2.default)('col-lg-4 col-sm-12') },
                  _react2.default.createElement(
                    'p',
                    null,
                    'z\xE1klady atletick\xE9 p\u0159\xEDpravy'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: (0, _classnames2.default)('col-lg-4 col-sm-12') },
                  _react2.default.createElement(
                    'p',
                    null,
                    'v\xFDuka in-line bruslen\xED'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: (0, _classnames2.default)('col-lg-4 col-sm-12') },
                  _react2.default.createElement(
                    'p',
                    null,
                    'm\xED\u010Dov\xE9 hry'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: (0, _classnames2.default)('col-lg-4 col-sm-12') },
                  _react2.default.createElement(
                    'p',
                    null,
                    'plav\xE1n\xED'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: (0, _classnames2.default)('col-lg-4 col-sm-12') },
                  _react2.default.createElement(
                    'p',
                    null,
                    'v\xFDtvarn\xE1 \u010Dinnost'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: (0, _classnames2.default)('col-lg-4 col-sm-12') },
                  _react2.default.createElement(
                    'p',
                    null,
                    'hry v t\xFDmu'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: (0, _classnames2.default)('col-lg-4 col-sm-12') },
                  _react2.default.createElement(
                    'p',
                    null,
                    'hry v p\u0159\xEDrod\u011B'
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: (0, _classnames2.default)('col-xs-12') },
              _react2.default.createElement(
                'h2',
                null,
                'Denn\xED program'
              ),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'strong',
                  null,
                  '7:45-8:00'
                ),
                ' Sraz na vlakov\xE9m n\xE1dra\u017E\xED Praha-Sm\xEDchov (po domluv\u011B je mo\u017En\xFD sraz tak\xE9 na n\xE1dra\u017E\xED Vr\u0161ovice)'
              ),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'strong',
                  null,
                  '8:20'
                ),
                ' P\u0159\xEDjezd do Radot\xEDna'
              ),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'strong',
                  null,
                  '8:20-12:00'
                ),
                ' Dopoledn\xED tr\xE9nink: in-line bruslen\xED, atletick\xFD tr\xE9nink, m\xED\u010Dov\xE9 hry'
              ),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'strong',
                  null,
                  '12:30'
                ),
                ' Ob\u011Bd v restauraci v T\u0159ebotov\u011B'
              ),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'strong',
                  null,
                  '13:00-14:00'
                ),
                ' Odpo\u010Dinkov\xFD program (v\xFDtvarn\xE1 \u010Dinnost, spole\u010Densk\xE9 hry)'
              ),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'strong',
                  null,
                  '14:00-16:40'
                ),
                ' Spole\u010Dn\xE9 hry v\xA0t\xFDmech/plav\xE1n\xED'
              ),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'strong',
                  null,
                  '16:45'
                ),
                ' Odjezd do Prahy'
              ),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'strong',
                  null,
                  '17:00'
                ),
                ' Vyzved\xE1v\xE1n\xED d\u011Bt\xED na Sm\xEDchovsk\xE9m n\xE1dra\u017E\xED (po domluv\u011B je mo\u017En\xE9 vyzved\xE1vat na n\xE1dra\u017E\xED Vr\u0161ovice)'
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)('container-fluid', styles.photos) },
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col-xs-4' },
              _react2.default.createElement(
                _reactLazyLoad2.default,
                { offsetBottom: lazyLoadOffset, offsetTop: lazyLoadOffset },
                _react2.default.createElement('img', { src: photos.photo3, alt: 'D\u011Btsk\xFD t\xE1bor Nenud\xEDm se' })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-xs-4' },
              _react2.default.createElement(
                _reactLazyLoad2.default,
                { offsetBottom: lazyLoadOffset, offsetTop: lazyLoadOffset },
                _react2.default.createElement('img', { src: photos.photo4, alt: 'D\u011Btsk\xFD t\xE1bor Nenud\xEDm se' })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-xs-4' },
              _react2.default.createElement(
                _reactLazyLoad2.default,
                { offsetBottom: lazyLoadOffset, offsetTop: lazyLoadOffset },
                _react2.default.createElement('img', { src: photos.photo5, alt: 'D\u011Btsk\xFD t\xE1bor Nenud\xEDm se' })
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: (0, _classnames2.default)('col-xs-12 col-sm-6 col-sm-offset-3', styles.priceIncludes) },
              _react2.default.createElement(
                'p',
                null,
                'V cen\u011B p\u0159\xEDm\u011Bstsk\xE9ho t\xE1bora ',
                _react2.default.createElement(
                  'strong',
                  null,
                  '1 990 K\u010D'
                ),
                ' je zahrnuto:'
              ),
              _react2.default.createElement(
                'ul',
                { className: styles.list },
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement('i', { className: 'fa fa-check', 'aria-hidden': 'true' }),
                  ' ob\u011Bd (hlavn\xED j\xEDdlo a pol\xE9vka)'
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement('i', { className: 'fa fa-check', 'aria-hidden': 'true' }),
                  ' dv\u011B sva\u010Diny b\u011Bhem dne'
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement('i', { className: 'fa fa-check', 'aria-hidden': 'true' }),
                  ' pitn\xFD re\u017Eim po cel\xFD den'
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement('i', { className: 'fa fa-check', 'aria-hidden': 'true' }),
                  ' vstup do plaveck\xE9ho are\xE1lu Biotop'
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement('i', { className: 'fa fa-check', 'aria-hidden': 'true' }),
                  ' doprava ze Sm\xEDchovsk\xE9ho n\xE1dra\u017E\xED a zp\u011Bt'
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement('i', { className: 'fa fa-check', 'aria-hidden': 'true' }),
                  ' tri\u010Dko'
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: (0, _classnames2.default)('col-xs-12 col-sm-6 col-sm-offset-3', styles.priceIncludes) },
              _react2.default.createElement(
                'p',
                null,
                'Cena ',
                _react2.default.createElement(
                  'strong',
                  null,
                  'nezahrnuje'
                ),
                ':'
              ),
              _react2.default.createElement(
                'ul',
                { className: styles.list },
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement('i', { className: (0, _classnames2.default)('fa fa-times', styles.not), 'aria-hidden': 'true' }),
                  ' vybaven\xED na in-line bruslen\xED'
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'container-fluid darker-container' },
          _react2.default.createElement(
            'div',
            { className: 'container' },
            _react2.default.createElement(
              'div',
              { className: (0, _classnames2.default)('col-xs-12', styles.shortApplicationForm) },
              _react2.default.createElement(
                'h2',
                { className: styles.applicationHeading },
                'P\u0159ihl\xE1\u0161ka'
              ),
              false && _react2.default.createElement(_components.ApplicationForm, { onSubmit: this.handleSubmit, repeat: this.handleRepeat, preFilled: preFilled }),
              true && _react2.default.createElement(
                'p',
                null,
                'Je n\xE1m l\xEDto, ale tento term\xEDn je pln\xFD. ',
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: '/primestske-tabory', title: 'P\u0159\xEDm\u011Bstsk\xE9 t\xE1bory' },
                  'Vyberte si pros\xEDm jin\xFD term\xEDn p\u0159\xEDm\u011Bstsk\xE9ho t\xE1bora'
                ),
                '.'
              )
            )
          )
        )
      );
    }
  }]);
  return SuburbanCamp;
}(_react.Component), _class2.propTypes = {
  initialize: _react.PropTypes.func.isRequired,
  params: _react.PropTypes.object.isRequired,
  saveApplicationForm: _react.PropTypes.func.isRequired,
  showForm: _react.PropTypes.func.isRequired,
  hideForm: _react.PropTypes.func.isRequired
}, _temp2)) || _class) || _class);
exports.default = SuburbanCamp;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/SuburbanCamp/SuburbanCamp.js
// module id = 1114
// module chunks = 0